import Time from "./currentTime/Time";
import Views from "./numOfViews/Views";
import ThreeDBlock from "./threeDBlock/ThreeDBlock";
import ThreeDCard from "./threeDCard/ThreeDCard";
import TicTacToe from "./ticTacToe/TicTacToe";
import Weather from "./weatherInfo/Weather";
import Leetcode from "./leetcode/Leetcode";

const funComponents = [
  {
    id: 0,
    name: "Number of views for each page",
    fun: <Views />,
  },
  {
    id: 1,
    name: "Weather",
    fun: <Weather />,
  },
  {
    id: 2,
    name: "Leetcode",
    fun: <Leetcode />,
  },
  {
    id: 3,
    name: "Current time",
    fun: <Time />,
  },
  {
    id: 4,
    name: "Tic Tac Toe game",
    fun: <TicTacToe />,
  },
  {
    id: 5,
    name: "3D card",
    fun: <ThreeDCard />,
  },
  {
    id: 6,
    name: "3D block",
    fun: <ThreeDBlock />,
  },
];

export default funComponents;

